<div class="pt-4 bg-white vh-100">
  <div class="d-flex justify-content-end pe-4">
    <div (click)="goToFmLms()" class="alert alert-primary cursor-pointer">
      <b>Looking for the FM LMS?</b> Click here.
    </div>
  </div>
  <div class="d-flex justify-content-center pb-0">
    <img
      class="py-2 px-4"
      src="../../assets/images/fm-logo.png"
      alt="foster-melliar logo"
      width="40%"
    />
  </div>
  <div class="d-flex justify-content-center pb-2">
    <h1 class="text-dark fs-1">
      Learner Management Solution
    </h1>
  </div>
  <div class="d-flex justify-content-between align-items-center mt-4">
    <div class="w-100 bg-fm-blue shadow" style="height: 100px"></div>
    <img
      class="py-4"
      src="../../assets/images/fm-stock-image.jpg"
      alt="foster-melliar logo"
      width="800px"
      class="shadow rounded"
    />
    <div class="w-100 bg-fm-blue shadow" style="height: 100px"></div>
  </div>
  <div class="d-flex justify-content-center pt-4 px-5 mx-5">
    <h2 class="text-dark text-center mx-5 px-5">
      Our Learner Management Software is crafted to support the unique needs of
      learnership programs in South Africa. We ensure full compliance with the
      Quality Council for Trades and Occupations (QCTO) and Sector Education and
      Training Authorities (SETAs). Our solution is designed to simplify the
      management of both theoretical instruction and practical workplace
      experience, paving the way for formal, nationally recognized
      qualifications.
    </h2>
  </div>
</div>
